
/**
 *	Stellt ALLEN Components Methode bereit.
 * 
 *	Einbindung in main.js über:
 * 
 *	import CommonMethods from './plugins/methods'
 *	Vue.use( CommonMethods );
 *
 */
import { API_URL, DATA_URL, ASSETS_URL } from "@/common/config";

export default {
	install (Vue, options) {	

		/**
		 * 	Prüfen, ob Event auf einem Element stattfand.
		 * 	
		 */
		Vue.prototype.hitTest = function ( event ) {
			var path = event.path || (event.composedPath && event.composedPath());
			return path.indexOf(this.$el) > -1;
		}

		Vue.prototype.normalizeEvent = function ( event ) {
			var ref = event.touches ? event.touches[0] : event;
			return {
				x: ref.pageX,
				y: ref.pageY,
				tstamp: event.timeStamp,
			}
		}
		
		/**
		 * 	Pfad zu Media holen
		 * 	
		 */
		Vue.prototype.getMediaPath = function ( img ) {
			if (!img) return '';
			return ASSETS_URL + img;
		}
		
		/**
		 *	Übersetzen von Daten
		 * 	Einfach im Template per {{ LL('key') }}
		 */
		Vue.prototype.LL = function ( key ) {
			return this.$store.state.LL.lang[key] || '';
		}

	}
}


// WEBPACK FOOTER //
// ./src/plugins/methods.js